import { Typography } from "antd/lib";
import type { FC } from "react";
import React, { useMemo } from "react";
import type { Dayjs } from "dayjs";
import { useTranslations } from "next-intl";
import dayjsConfig from "@/utils/dayjsConfig";

const LastUpdated: FC<{
  dateTime: string | Date | Dayjs | undefined;
  className?: string;
}> = ({ dateTime, className }) => {
  const t = useTranslations("common");
  const data = useMemo(() => dayjsConfig(dateTime).fromNow(), [dateTime]);

  return (
    <Typography.Text type={"secondary"} className={className}>
      {t("last_update")} {data}
    </Typography.Text>
  );
};

export default LastUpdated;
